// accessCopy — single job: the message a signed-in user sees when /api/beta-status denies access.
// Shared by the screenshot importer (AddSlipSheet) and SlipSync (ImportMethodSheet) so both say the same thing.
// SlipTrack is invite-only (#1503): an account without an approval row is 'not_found' and waits for approval.

export function accessDeniedMessage(status) {
  if (status === "waitlist") {
    return "You're on the SlipTrack beta waitlist. Access has not been enabled for this account yet.";
  }
  if (status === "revoked" || status === "blocked") {
    return "This account does not currently have access to SlipTrack beta.";
  }
  if (status === "consent_missing") {
    return "Finish the age check and accept the Terms and Privacy Policy to import slips. If you already did, tap Check again.";
  }
  return "Your account is waiting for approval. SlipTrack is invite-only during the beta. Email hello@sliptrack.net to request access.";
}
